"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importStar(require("react"));
const classnames_1 = __importDefault(require("classnames"));
const IconSizes_1 = require("../../Icons/PropTypes/IconSizes");
const Icons_1 = require("../../Icons");
const types_1 = require("../types");
const className = "dropzone-preview-image";
const DropzonePreviewImage = ({ file }) => {
    var _a, _b, _c, _d;
    let IconComponent;
    let imageSrc = "";
    let fileTypeClassName = "";
    // Any image file except Tiff because chrome does not support displaying tiff images
    if (file.type !== types_1.DropzoneMIMEType.Tiff && (file === null || file === void 0 ? void 0 : file.type.startsWith("image/"))) {
        imageSrc = URL.createObjectURL(file);
        return react_1.default.createElement("img", { className: className, src: imageSrc });
    }
    const lastDotIndex = (_a = file.name) === null || _a === void 0 ? void 0 : _a.lastIndexOf(".");
    const displayNameExtension = (_b = file.name) === null || _b === void 0 ? void 0 : _b.substring(lastDotIndex);
    switch (displayNameExtension) {
        case ".aac":
        case ".m4a":
        case ".mp3":
        case ".wma":
        case ".mp4a":
        case ".ogg":
            IconComponent = Icons_1.FileAudioIcon;
            fileTypeClassName = "audio";
            break;
        case ".mov":
        case ".mp4":
        case ".avi":
        case ".webm":
        case ".mkv":
        case ".wmv":
            IconComponent = Icons_1.FileVideoIcon;
            fileTypeClassName = "video";
            break;
        case ".doc":
        case ".docx":
            IconComponent = Icons_1.FileDocxIcon;
            fileTypeClassName = "docx";
            break;
        case ".xlsx":
            IconComponent = Icons_1.FileXlsxIcon;
            fileTypeClassName = "xlsx";
            break;
        case ".pdf":
            IconComponent = Icons_1.FilePdfIcon;
            fileTypeClassName = "pdf";
            break;
        case ".txt":
        case ".ppt":
        case ".pptx":
            IconComponent = Icons_1.FileIcon;
            break;
        default:
            IconComponent = Icons_1.FileIcon;
            break;
    }
    // Fallback in case the file extension is not enough
    if (IconComponent === Icons_1.FileIcon) {
        // Any video file
        if ((_c = file.type) === null || _c === void 0 ? void 0 : _c.startsWith("video/")) {
            IconComponent = Icons_1.FileVideoIcon;
            fileTypeClassName = "video";
        }
        // Any audio file
        else if ((_d = file.type) === null || _d === void 0 ? void 0 : _d.startsWith("audio/")) {
            IconComponent = Icons_1.FileAudioIcon;
            fileTypeClassName = "audio";
        }
        else {
            switch (file.type) {
                case types_1.DropzoneMIMEType.Doc:
                case types_1.DropzoneMIMEType.Docx:
                    IconComponent = Icons_1.FileDocxIcon;
                    fileTypeClassName = "docx";
                    break;
                case types_1.DropzoneMIMEType.Xls:
                case types_1.DropzoneMIMEType.Xlsx:
                    IconComponent = Icons_1.FileXlsxIcon;
                    fileTypeClassName = "xlsx";
                    break;
                case types_1.DropzoneMIMEType.Pdf:
                    IconComponent = Icons_1.FilePdfIcon;
                    fileTypeClassName = "pdf";
                    break;
                case types_1.DropzoneMIMEType.Tiff:
                    IconComponent = Icons_1.FileImageIcon;
                    fileTypeClassName = "tiff";
                    break;
                default:
                    IconComponent = Icons_1.FileIcon;
            }
        }
    }
    (0, react_1.useEffect)(() => {
        return () => {
            if (imageSrc) {
                URL.revokeObjectURL(imageSrc);
            }
        };
    });
    return (react_1.default.createElement("div", { className: (0, classnames_1.default)(className, fileTypeClassName) },
        react_1.default.createElement(IconComponent, { size: IconSizes_1.IconSizes.Medium })));
};
exports.default = DropzonePreviewImage;
//# sourceMappingURL=DropzonePreviewImage.js.map